import '../App.css';
import { useState, useEffect } from 'react';
import axios from '../apis/Axios';
import { SERVER_URL } from '../apis/Api';

function ArtworkGallery(props) {
    const { onAllImagesLoaded, onError } = props;
    const [images, setImages] = useState([]);
    const [loadedImages, setLoadedImages] = useState(new Set());

    useEffect(() => {
        const getImageData = async () => {          
            try { 
                const res = await axios.get('api/general/images/artwork');

                setImages(res.data);

                res.data.forEach((img, index) => {
                    const image = new Image();
                    image.onload = () => {
                        setLoadedImages(prev => new Set([...prev, img.name]));
                        if (loadedImages.size === res.data.length - 1) {
                            onAllImagesLoaded?.();
                        }
                    };

                    image.onerror = (err) => {
                        console.log('Failed to load image: ', img.name);
                        setLoadedImages(prev => new Set([...prev, img.name]));
                    };
                    image.src = SERVER_URL + img.url;
                });
                
                onAllImagesLoaded?.();
            } catch (err) {
                console.log(err);
                onError?.(err);
            }
        };
        
        getImageData();
    }, [onAllImagesLoaded, onError]);

    return (
        <div style={{ maxWidth: '100%', margin: '4vw auto', padding: '0 10px' }}>
            <div className='artwork-gallery'>
                <div className='artwork-gallery-grid' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {   
                        images.map((img) => {
                            const isLoaded = loadedImages.has(img.name);
                            return (
                                <div key={ img.name } style={{ marginBottom: '20px' }}>
                                    <img
                                        src={`${SERVER_URL + img.url}`}
                                        alt=''
                                        style={{ 
                                            maxWidth: '100%', 
                                            height: 'auto', 
                                            borderRadius: '8px',
                                            opacity: isLoaded ? 1 : 0.6,
                                            transition: 'opacity 0.3s ease'
                                        }}
                                        onError={(e) => console.log('Failed to load the image: ', e.target.src)}
                                    />
                                    <div className='artwork-gallery-item-caption'>
                                        { img.title }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default ArtworkGallery;